module.exports = __webpack_public_path__ + "img/27_70.053014a4.png";